import { defineComponent } from 'vue';
import { KycTypes } from '@/types/kyc';
import router from '@/router';
import { storeToRefs } from 'pinia';
import { useKycStore } from '@/store/modules/kyc';
export default defineComponent({
    name: 'VerificationPending',
    setup() {
        const kycStore = useKycStore();
        const { currentStep: kycStep } = storeToRefs(kycStore);
        const checkVerificationStatus = () => {
            kycStep.value = KycTypes.KycSteps.VERIFICATION_STATUS;
            router.push('/kyc');
        };
        const keypress = () => {
            console.log();
        };
        return {
            checkVerificationStatus,
            keypress,
        };
    },
});
